import { useState, useEffect, useRef } from 'react'
import { createGeneralApi } from '../tbsGeneralApi'
import { cn, toStyleObject } from '@/lib/utils'

export default function LabelField({ id, label, for: labelFor, visible, compoGroup, userData, class: cssClass, style: rawStyle }) {
  // `visible: false` (JSON) → display:none posé directement sur le div [data-tbs-root] : voir
  // ChampField.jsx pour le détail (show()/hide() de tbsGeneralApi.js ciblent ce même élément).
  const visibilityStyle = visible === false ? { display: 'none' } : undefined
  const cssStyle = toStyleObject(rawStyle)
  const [text, setText]       = useState(label)
  const compoGroupRef = useRef(compoGroup ?? null)
  const userDataRef   = useRef(userData ?? null)
  const textRef        = useRef(null)

  useEffect(() => {
    window.tbsComponents = window.tbsComponents ?? {}
    window.tbsComponents[id] = {
      type: 'label',
      ...createGeneralApi(id, userDataRef.current),
      getCompoGroup: () => compoGroupRef.current,
      setCompoGroup: v => { compoGroupRef.current = v },
      setText: t => setText(t),
    }
    return () => { delete window.tbsComponents[id] }
  }, [id])

  // Tooltip affiché uniquement si le texte est effectivement tronqué (ellipsis) au survol —
  // contrairement aux en-têtes de colonnes (TableField/TreeField), LabelField n'a pas d'attribut
  // `tooltipText` : rien à afficher quand le libellé tient déjà en entier. `text` est du HTML
  // (dangerouslySetInnerHTML, non échappé — même convention que setHtml() sur Canvas/Widget) :
  // le tooltip natif (`title`) utilise `textContent` (texte déjà dépouillé de ses balises par le
  // DOM), pas `text` brut, pour éviter d'afficher des balises HTML dans l'infobulle.
  const handleMouseEnter = () => {
    const el = textRef.current
    if (!el) return
    if (el.scrollWidth > el.clientWidth) el.title = el.textContent
    else el.removeAttribute('title')
  }

  const cls = "text-sm font-semibold text-[hsl(var(--foreground))] truncate block max-w-full text-right"
  return (
    <div id={id} className={cn('mb-2', cssClass)} data-tbs-root={id} style={{ minWidth: 0, ...cssStyle, ...visibilityStyle }}>
      {labelFor
        ? <label ref={textRef} htmlFor={labelFor} className={cls} onMouseEnter={handleMouseEnter} dangerouslySetInnerHTML={{ __html: text }} />
        : <span  ref={textRef}                     className={cls} onMouseEnter={handleMouseEnter} dangerouslySetInnerHTML={{ __html: text }} />
      }
    </div>
  )
}
